import React, { useState,useEffect } from 'react';
import './DesktopNavbar.css';
import CarryMyPet from '../../../images/cmp_logo_minidrawer.svg';
import Notify from '../../../images/notify.svg';
import User from '../../../images/user.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser,faPaw,faLock ,faRightFromBracket} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import axios from "axios";

function DesktopNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const baseAPI = process.env.REACT_APP_API_URL;
  const [orderSummary, setOrderSummary] = useState([]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const email = JSON.parse(localStorage.getItem("email"));

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("accessToken"));

    if (storedToken) {
      axios
        .get(`${baseAPI}customerget/GetCustomerProfileInfo?email=` + email, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (response) {
            setOrderSummary(response.data.data[0]);

          } else {
            console.error(
              "Invalid token or expired session:",
              response.data.message
            );
            // Handle invalid token scenario
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
          if (error.response) {
            console.error("Response Data:", error.response.data);
            console.error("Response Status:", error.response.status);
            console.error("Response Headers:", error.response.headers);
          }
        });
    } else {
      console.error("No token found, redirect to login or show error");
    }
  }, []);

  function SignOut(){
    localStorage.removeItem("accessToken");
    localStorage.removeItem("email");
  }

  return (
    <div className=''>
      <div
        style={{ position: 'fixed' }}
        className='row top-button-main d-flex justify-content-between align-items-center '
      >
        <div className='col-2 px-4'>
          <img src={CarryMyPet} className='img-fluid' alt="CarryMyPet Logo" />
        </div>
        <div className='col-8 text-end px-4'>
          <img src={Notify} className='img-fluid' alt="Notifications" />
        </div>
        <div className='col-2 top-button-right d-flex justify-content-start align-items-center '>
          <img
            src={User}
            style={{ width: '45px', marginLeft: '20px', marginRight: '15px', cursor: 'pointer' }}
            className='img-fluid'
            alt="User"
            onClick={toggleMenu}
          />
          <div className='text-start d-flex flex-column align-items-center p-0 mt-2'>
            <h2 style={{ color: 'white', fontSize: '15px' }}>{orderSummary.First_Name} {orderSummary.Last_Name}</h2>
            <h3 style={{ color: 'white', fontSize: '12px' }}>{orderSummary.Email}</h3>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className='profile-menu'>
         <ul className='list-unstyled m-0 p-3'>
      <li>
        <Link to="/customerProfile" style={{ color: "#6a6a6a", textDecoration: "none" }} 
        // onClick={() => nextPage(item.Relocation_ID)}
        >
          <FontAwesomeIcon icon={faUser} style={{ marginRight: '10px' }} /> Customer Profile
        </Link>
      </li>
      <li>
        <Link to="/petProfile" style={{ color: "#6a6a6a", textDecoration: "none" }}>
          <FontAwesomeIcon icon={faPaw} style={{ marginRight: '10px' }} /> Pet Profile
        </Link>
      </li>
      <li>
        <Link to="/changePassword" style={{ color: "#6a6a6a", textDecoration: "none" }}>
          <FontAwesomeIcon icon={faLock} style={{ marginRight: '10px' }} /> Change Password
        </Link>
      </li>
      <li onClick={() => SignOut()}>
        <Link to="/"  style={{ color: "#6a6a6a", textDecoration: "none" }}>
          <FontAwesomeIcon icon={faRightFromBracket} style={{ marginRight: '10px' }} /> Log out
        </Link>
      </li>
    </ul>
        </div>
      )}
    </div>
  );
}

export default DesktopNavbar;
